/*
 Copyright (C) 2018 3NSoft Inc.

 This program is free software: you can redistribute it and/or modify it under
 the terms of the GNU General Public License as published by the Free Software
 Foundation, either version 3 of the License, or (at your option) any later
 version.

 This program is distributed in the hope that it will be useful, but
 WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 this program. If not, see <http://www.gnu.org/licenses/>.
*/

export function messageListToArray(list: {[key: string]: client3N.MessageListItem}): client3N.MessageListItem[] {
  const res: client3N.MessageListItem[] = [];
  Object.keys(list).forEach((key: string) => {
    res.push(list[key]);
  });
  return res;
}

export function getMessageListByFolder(data: client3N.MessageListItem[], folderId: string): client3N.MessageListItem[] {
  return data.filter(item => item.folderId === folderId);
}
